// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8464b42c","551":"449ddfde","950":"89b839c3"}[chunkId] + ".chunk.js";
};